/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_File_Operations_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "File operations" |
*
* @param {Toolbar_Secondary_File_Operations_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_file_operations_aria_label = /** @type {((inputs?: Toolbar_Secondary_File_Operations_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_File_Operations_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opérations sur les fichiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateivorgänge")
	if (locale === "it") return /** @type {LocalizedString} */ ("Operazioni sui file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("файловые операции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Operaciones con archivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件操作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル操作")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल संचालन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Operações com arquivos")
	return /** @type {LocalizedString} */ ("File operations")
});